import { defineMessages } from '@sm/intl';

export default defineMessages({
  ENTERPRISE: {
    id: 'getDrawerData.enterprise',
    defaultMessage: 'Enterprise',
    description:
      '[Type: Label][Vis.: high] - This is the Enterprise section of the side menu.',
  },
  ENTERPRISE_SUBTITLE: {
    id: 'getDrawerData.enterprise_subtitle',
    defaultMessage: 'Get more security & control over your survey data',
    description:
      '[Type: Label][Vis.: high] - This is the Enterprise subtitle section of the side menu.',
  },
  AUDIENCE: {
    id: 'getDrawerData.audience',
    defaultMessage: 'Audience',
    description: '[Type: Label][Vis.: low] - Audience section of sidemenu',
  },
  AUDIENCE_SUBTITLE: {
    id: 'getDrawerData.audienceSubtitle',
    defaultMessage: 'Collect survey responses from our global consumer panel',
    description: '[Type: Label][Vis.: low] - Audience subtitle of sidemenu',
  },
  INTEGRATIONS_AND_PLUGINS: {
    id: 'getDrawerData.integrationsAndPlugins',
    defaultMessage: 'Integrations & Plug-ins',
    description: '[Type: Label][Vis.: low] - integrations label of submenu',
  },
  INTEGRATIONS_AND_PLUGINS_SUBTITLE: {
    id: 'getDrawerData.integrationsAndPluginsSubtitle',
    defaultMessage: 'Easily connect survey data to existing business systems',
    description:
      '[Type: Label][Vis.: low] - integrations subtitle section of submenu',
  },
  WUFOO_SUBTITLE: {
    id: 'getDrawerData.wufooSubtitle',
    defaultMessage: 'Gather data & payments with online forms',
    description: '[Type: Label][Vis.: low] - wufoo subtitle section of submenu',
  },
  APPLY_SUBTITLE: {
    id: 'getDrawerData.applySubtitle',
    defaultMessage: 'Collect, review & manage applications online',
    description: '[Type: Label][Vis.: low] - apply subtitle section of submenu',
  },
  USABILLA_SUBTITLE: {
    id: 'getDrawerData.usabillaSubtitle',
    defaultMessage: 'Get in-the-moment feedback across all digital channels',
    description:
      '[Type: Label][Vis.: low] - Usabilla subtitle section of submenu',
  },
  PRODUCTS_FOOTNOTE: {
    id: 'getDrawerData.productsFootnote',
    defaultMessage:
      'Net Promoter Score and NPS are registered trademarks of Bain & Company, Inc., Fred Reichheld and Satmetrix Systems, Inc.',
    description:
      '[Type: Label][Vis.: low] - products footnote section of submenu',
  },
  HELP_CENTER: {
    id: 'getDrawerData.helpCenter',
    defaultMessage: 'Help Center',
    description: '[Type: Label][Vis.: low] - Help Center section of submenu',
  },
  HELP_CENTER_SUBTITLE: {
    id: 'getDrawerData.helpCenterSubtitle',
    defaultMessage: 'Find quick answers to your questions',
    description:
      '[Type: Label][Vis.: low] - Help Center subtitle section of submenu',
  },
  SURVEYMONKEY_BLOG: {
    id: 'getDrawerData.SurveyMonkeyBlog',
    defaultMessage: 'Curiosity at Work',
    description: '[Type: Label][Vis.: low] - SurveyMonkey section of submenu',
  },
  SURVEYMONKEY_BLOG_SUBTITLE: {
    id: 'getDrawerData.SurveyMonkeyBlogSubtitle',
    defaultMessage: 'Get inspiration on our blog',
    description:
      '[Type: Label][Vis.: low] - SurveyMonkey blog subtitle of submenu',
  },
});
